import { render } from "./OnTheJobDocumentScreen.vue?vue&type=template&id=18235d91"
import script from "./OnTheJobDocumentScreen.vue?vue&type=script&lang=ts"
export * from "./OnTheJobDocumentScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script